﻿import { useRef, useEffect } from 'react'

const QuestionWrapper = ({
    children,
    question,
    index,
    tabIndex,
    onAnswered,
    ...props
}) => {

    // animation
    const animationConfig = { behavior: "smooth", block: 'nearest', inline: 'start' }
    const questionRefs = useRef([]);

    useEffect(() => {
        if (questionRefs.current[index]) {
            questionRefs.current[index].scrollIntoView( animationConfig );
        }
    }, [index, question]);

    return (
        <section
            onClick={onAnswered}
            tabIndex={tabIndex}
            className={props.classes}
            ref={(element) => (questionRefs.current[index] = element)}
        >
            <div className="pension-wizard-block__question__card">
                {children}
            </div>
        </section>
    )
}

export default QuestionWrapper;
